import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantEntity
